export const allOptionCategory = "הכל";
